export default __webpack_public_path__ + "static/media/preloader-img.b28e171f.svg";